export interface PlatformEdgeProps {
  opacity?: number;
  top?: number | string;
  bottom?: number | string;
}

export function PlatformEdge({
  opacity = 1,
  top = "auto",
  bottom = 110,
}: PlatformEdgeProps) {
  return (
    <div
      style={{
        position: "absolute",
        left: 28,
        right: 28,
        top,
        bottom,
        height: 1,
        pointerEvents: "none",
        opacity,
        zIndex: 0,
        backgroundImage:
          "repeating-linear-gradient(90deg, rgba(14,14,14,0.18) 0 6px, transparent 6px 12px)",
      }}
    />
  );
}
